import React from "react";
import { Link } from "react-router-dom";
import { Butterfly } from "./LogoMark";

const Footer = () => (
  <footer className="hairline-t mt-32" data-testid="site-footer">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
      <div>
        <div className="flex items-center gap-3">
          <Butterfly size={18} />
          <span className="serif text-2xl tracking-[0.2em]">MELAVI</span>
        </div>
        <p className="mt-6 text-sm text-ink/70 leading-relaxed max-w-[24ch]">
          Small clothes, made slowly.<br />Bengaluru, since a lunch in 2024.
        </p>
      </div>

      <div>
        <h4 className="nav-item mb-5">Shop</h4>
        <ul className="space-y-3 text-sm">
          <li><Link to="/product-category/girls" className="hover:text-accent" data-testid="foot-girls">Girls</Link></li>
          <li><Link to="/product-category/boys" className="hover:text-accent" data-testid="foot-boys">Boys</Link></li>
          <li><Link to="/adults" className="hover:text-accent" data-testid="foot-adults">Adults</Link></li>
          <li><Link to="/twinning" className="hover:text-accent" data-testid="foot-twinning">Twinning</Link></li>
          <li><Link to="/shop" className="hover:text-accent" data-testid="foot-all">All pieces</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="nav-item mb-5">The House</h4>
        <ul className="space-y-3 text-sm">
          <li><Link to="/our-story" className="hover:text-accent">Our story</Link></li>
          <li><Link to="/the-craft" className="hover:text-accent">The craft</Link></li>
          <li><Link to="/journal" className="hover:text-accent">Journal</Link></li>
          <li><Link to="/frequently-asked-questions" className="hover:text-accent">FAQs</Link></li>
          <li><Link to="/contact-us" className="hover:text-accent">Contact</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="nav-item mb-5">Policies</h4>
        <ul className="space-y-3 text-sm">
          <li><Link to="/return" className="hover:text-accent">Returns</Link></li>
          <li><Link to="/terms-conditions" className="hover:text-accent">Terms</Link></li>
          <li><Link to="/privacy-policy" className="hover:text-accent">Privacy</Link></li>
          <li><Link to="/tracking-order" className="hover:text-accent">Track order</Link></li>
        </ul>
        <p className="mt-6 text-xs text-ink/60 leading-relaxed">
          Melavi.in@gmail.com<br />+91 81235 41555<br />
          #1991, JP Nagar 2nd Phase, Bengaluru 560078
        </p>
      </div>
    </div>
    <div className="hairline-t">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 py-6 flex flex-wrap items-center justify-between gap-4 text-xs text-ink/60">
        <span>© {new Date().getFullYear()} MeLaVi Creations. GSTIN 29ACCFM9675R1Z0.</span>
        <span className="flex items-center gap-4">
          <span>Made with slow hands in Bengaluru.</span>
          <Link
            to="/admin/login"
            className="inline-flex items-center gap-2 px-3 py-1.5 tracking-[0.28em] uppercase text-[11px] transition-colors hover:bg-ink hover:text-ground"
            style={{ border: "1px solid var(--ink)", color: "var(--ink)" }}
            data-testid="footer-studio-link"
            title="Studio · admin sign-in"
          >
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
              <rect x="4" y="10" width="16" height="10" rx="1.5" />
              <path d="M8 10V7a4 4 0 0 1 8 0v3" />
            </svg>
            Studio
          </Link>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
